const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  optionValueSelectionChange: 'option-value-selection-change',
  onStyleChange: 'style-change',
  onTypeChange: 'type-change',
  onPackColorsChange: 'pack-colors-change',
  onPackSizeChange: 'pack-size-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  sectionRefreshed: 'section-refreshed',
  pdpUpdate: 'pdp-updated'
}

/*
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
*/
